export const labels = {
    collectSignatures: (entity: string) =>
        `Please collect signatures and follow your firm’s established procedures for submitting paperwork to your ${entity}.`
};
